<template>
    <div class="modal vc_modal my_account_modal" :class="{ 'show': showBillingTypeModal}">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content my_account_modal_content p_0">
                <button type="button" class="btn-close" @click="closeModal()"></button>
                <div class="modal-body p_0">
                    <h5 class="common_subtitle pb_15  font_18p border-lightgray-bottom pt_15 pl_15">Update {{ modalData?.server_name }} billing interval</h5>
                    
                    <div class="p_20">
                        <div class="row">
                            <div class="col-12"> 
                                <div class="mb-3">
                                    <label for="inputEmail3" class="col-form-label">Billing type</label>
                                    <select class="form-select" v-model="form.billing_type">
                                        <option value="monthly">Monthly</option>
                                        <option value="hourly">Hourly</option>
                                    </select>
                                    <v-errors :errors="errorFor('billing_type')"></v-errors>
                                </div>
                                <div class="vm_checkout_right">
                                    <div class="vm_checkout_right_wrap">
                                        <h5 class="common_subtitle">Estimated Bill </h5>
                                        <div class="checkout_right_inner">
                                            <div class="d_flex_btwn inner_title">
                                                <span>Total estimated bill</span>
                                                <h2 v-if="form.billing_type == 'monthly'" class="subtotal">￦ {{ modalData?.serverProductType?.monthly_price }}</h2>
                                                <h2 v-else class="subtotal">￦ {{ modalData?.serverProductType?.hourly_price }}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="d_flex_start">
                                        <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click.prevent="updateRatePlan">Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "update-plan-modal",
    components: {},
    props: {
        showBillingTypeModal: {
            type: Boolean,
            required: true
        },
        modalData: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            cloudServers: [],
            form: {
                billing_type: this.modalData?.billing_type,
                cloud_server_id: this.modalData?.id,
            }
        }
    },
    watch: {
        
    },
    created() {
    },
    methods: {
        updateRatePlan() {
            this.$swal({
                title: 'Are you sure want to update?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, update it!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    if(this.form.billing_type == 'monthly'){
                        this.form.price = this.modalData?.serverProductType?.monthly_price
                    }else{
                        this.form.price = this.modalData?.serverProductType?.hourly_price
                    }
                    this.axios.post('/update-cloud-server-plan',this.form)
                    .then((response) => {
                        if(response.data.success){
                            this.closeModal();
                            this.showSuccessMsg(response.data.message);
                        }else{
                            this.$swal({
                                text: response.data.message,
                                showCancelButton: false,
                                confirmButtonText: 'Close!',
                                confirmButtonColor: '#dd4b39',
                                reverseButtons: true
                            })
                        }
                    })
                    .catch((err) => {
                        this.allErrors = err.response.data.errors
                        this.showFailMsg(err.response.data.message);
                    });
                }
            });
        },
        closeModal() {
            this.$emit('closeBillingTypeModal', this.form.billing_type)
        }
    }
}
</script>
<style scoped>
    .modal{
        background-color: rgb(0 0 0 / 15%);
    }
</style>
